module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAMAAAAM7l6QAAAAXVBMVEUAaZkAaZkAaZkAaZkAaZkAaZkAaZlHcEwAaZkAaZkAaZkAaZkAaZkAaZkAaZkAaZkAaZkAaZkAaZkAaZkAaZkAaZkAaZkAaZkAaZkAaZkAaZkAaZkAaZkAaZkAaZl5jLN3AAAAHnRSTlMwUkRTsfrFAFDgj8YBRfmb4x8uxGIJbww597nSSiJNOL51AAAAkklEQVQoz93Tyw6DIBQE0KuC1Pfbaqvz/58pYhf1lkCiu07C6mwuyQwpnSCWYJFxsAvpl8Ka9OAIECGxhAKIDGcQufpJLpAZliiUJQWkYYBsTICLV8wuVsvk5M+/r/Hz/bpx+X9w82BpTlzzJtUnrhKW6sJpQ98PDh6BkfNXFduua3kVPUX2zMAzon2CJbfymOAGNQwoao2p6y4AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/login/signin_phone.png
// module id = RVNd
// module chunks = 1